import { makeStyles } from '@material-ui/core/styles';

import { hexToRGB } from 'core/helpers/styles-helpers';
const useStyles = makeStyles((theme) => ({
  iconSmall: {
    height: 14,
    marginTop: 6
  },
  notificationContentWithTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 14,
    marginBottom: theme.spacing(1)
  },
  residentInformation: {
    borderRadius: (index) => (index === 0 ? '6px 6px 0 0' : 0),
    backgroundColor: theme.colorPalette.beige_25,
    width: 720,
    padding: theme.spacing(4, 8),
    borderBottom: `2px solid ${hexToRGB(theme.colorPalette.beige_50, 0.5)}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameAndAge: {
    display: 'grid'
  },
  residentAge: {
    fontWeight: 600
  },
  residentName: {
    fontWeight: 400
  },
  trashContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  warningContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    borderRadius: '0 0 6px 6px',
    width: 720,
    backgroundColor: theme.colorPalette.beige_25,
    padding: theme.spacing(6, 8)
  },
  infoCard: {
    width: '100%',
    gap: theme.spacing(2),
    height: 96,
    backgroundColor: theme.colorPalette.beige_50,
    padding: theme.spacing(4, 4, 6),
    // marginBottom: theme.spacing(2),
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row',
    fontSize: 14
  },
  addResidentsTitle: {
    marginBottom: 16
  },
  addResidentContainer: {
    width: 720,
    borderRadius: theme.sizes.roundCorners,
    border: `2px solid ${theme.colorPalette.white}`,
    backgroundColor: theme.colors.page__background_primary,
    padding: theme.spacing(6, 8, 8, 8),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  button: {
    width: 'fit-content',
    alignSelf: 'center',
    fontSize: 16,
    padding: theme.spacing(0, 4),
    marginTop: theme.spacing(2)
  }
}));

export default useStyles;
